import { useEffect } from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import DashboardPage from '../../components/DashboardPage/DashboardPage';
import ErrorLayout from '../../components/Error/ErrorLayout';
import ToasterList, { useToaster } from '../../components/Toaster/ToasterList';
import PasswordUpdateForm from '../../features/password/components/PasswordUpdateForm';
import { passwordState } from '../../features/password/passwordSlice';
import ProfileInformationForm from '../../features/profileInformations/components/ProfileInformationForm';
import { getProfileInformation, profileInformationsState, resetProfileUpdated } from '../../features/profileInformations/profileInformationsSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/hooks';

const Profile = () => {
    const dispatch = useAppDispatch();
    const { profile, isLoading } = useAppSelector(profileInformationsState);

    useEffect(() => {
        if (!profile) {
            dispatch(getProfileInformation());
        }
    }, []);

    // Toast handling
    const { isUpdated } = useAppSelector(profileInformationsState);
    const { toastList, addToast } = useToaster();

    useEffect(() => {
        if (isUpdated) {
            addToast({ idx: 'profileupdated', theme: 'success', title: 'Success', body: () => (<>Profile updated !</>) });
            dispatch(resetProfileUpdated());
        }
    }, [isUpdated]);

    const { updatedPassword } = useAppSelector(passwordState);


    useEffect(() => {
        if (updatedPassword.error) {
            const error = updatedPassword.error;
            addToast({ idx: 'passwordUpdateError', theme: 'danger', title: 'Error', body: () => <ErrorLayout error={error} /> });
        }

        if (updatedPassword.isSuccess) {
            addToast({ idx: 'passwordUpdated', theme: 'success', title: 'Success', body: () => (<>Password updated !</>) });
        }

    }, [updatedPassword]);


    return (
        <>
            <DashboardPage heading="Profile">
                <Row className="my-3">
                    <Col md={6}>
                        <Card >
                            <Card.Header>
                                <Card.Title>Profile Informations</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <ProfileInformationForm profile={profile} isLoading={isLoading} />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card>
                            <Card.Header>
                                <Card.Title>Security</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Password</Accordion.Header>
                                        <Accordion.Body>
                                            <PasswordUpdateForm />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </DashboardPage>
            <ToasterList list={toastList} />
        </>
    )
}

export default Profile